import { render, staticRenderFns } from "./MembershipFamilyOffice.vue?vue&type=template&id=8e9a4572"
import script from "./MembershipFamilyOffice.vue?vue&type=script&lang=js"
export * from "./MembershipFamilyOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports